module.exports = __webpack_public_path__ + "static/img/thumb_20.3ff96e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_20.png
// module id = r16W
// module chunks = 0